<template>
  <transition name="fade">
    <div
      v-if="visible"
      class="modal-overlay"
      @click.self="close">
      <div class="modal-content">
        <button
          class="close-btn"
          @click="close">
          <v-icon>mdi-close</v-icon>
        </button>
        <img
          src="/img/new-feature.jpg"
          alt="New Feature"
          class="modal-image" />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      visible: false
    }
  },
  mounted() {
    const show = sessionStorage.getItem('once-modal-show')
    const now = new Date()
    const endDate = new Date('2025-12-31T23:59:59')

    // เงื่อนไข: ยังไม่เคยเปิด และวันที่ปัจจุบัน <= 31 Dec 2025
    if (!show && now <= endDate) {
      this.visible = true
      sessionStorage.setItem('once-modal-show', 'true')
    }
  },
  methods: {
    close() {
      this.visible = false
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.modal-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.modal-content {
  background: white;
  padding: 20px;
  position: relative;
  max-width: 700px;
  border-radius: 8px;
}
.close-btn {
  position: absolute;
  top: -7px; right: 0px;
  border: none;
  background: none;
  font-size: 24px;
  cursor: pointer;
}
.modal-image {
  max-width: 100%;
  height: auto;
}
</style>
